import { useQuery } from '@apollo/react-hooks';

import { SYLLABUS_MODE } from 'Domains/syllabus';

import { getCourseGradeReport, getTKCourseGradeReport } from '../../GraphQL/queries/report.query';

const CourseGradeReportData = ({ value, schoolCode, children }) => {
  const { term, grade, subject, mode } = value;

  const variables = {
    schoolTermId: term,
    schoolGradeId: grade,
    subjectId: subject,
    schoolCode,
  };

  const isSkip = !term || !grade || !subject || !schoolCode;

  const traditionalReport = useQuery(getCourseGradeReport, {
    variables: variables,
    skip: isSkip || mode === SYLLABUS_MODE.TUNGKAI,
  });

  const tungkaiReport = useQuery(getTKCourseGradeReport, {
    variables: variables,
    skip: isSkip || mode === SYLLABUS_MODE.TRADITIONAL,
  });

  const report = mode === SYLLABUS_MODE.TRADITIONAL ? traditionalReport : tungkaiReport;

  const { loading, error, data, refetch } = report;

  return children({ loading, error, data, refetch });
};

export default CourseGradeReportData;
